import { useState } from "react";
import type { Bank, VietQRData } from "../api";
import PhotoUploadStep from "./PhotoUploadStep";
import PhotoHalftoneStep from "./PhotoHalftoneStep";

type PhotoSubStep = "upload" | "halftone";

type Props = {
  bank: Bank;
  accountNumber: string;
  amount: number | undefined;
  qrData: VietQRData;
  onBack: () => void;
  onReset: () => void;
};

/** Luồng trộn ảnh: tải ảnh lên rồi đưa ảnh vào bên trong mã QR. */
export default function PhotoFlow({ bank, accountNumber, amount, qrData, onBack, onReset }: Props) {
  const [subStep, setSubStep] = useState<PhotoSubStep>("upload");

  const [fileId, setFileId] = useState<string | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  function handleUploaded(id: string, _width: number, _height: number, url: string) {
    setFileId(id);
    setPreviewUrl(url);
    setSubStep("halftone");
  }

  function handleChangePhoto() {
    if (previewUrl) URL.revokeObjectURL(previewUrl);
    setFileId(null);
    setPreviewUrl(null);
    setSubStep("upload");
  }

  if (subStep === "upload" || !previewUrl) {
    return <PhotoUploadStep onBack={onBack} onUploaded={handleUploaded} />;
  }

  if (subStep === "halftone" && fileId) {
    return (
      <PhotoHalftoneStep
        fileId={fileId}
        bank={bank}
        accountNumber={accountNumber}
        amount={amount}
        qrData={qrData}
        onBack={handleChangePhoto}
        onChangePhoto={handleChangePhoto}
        onReset={onReset}
      />
    );
  }

  return <PhotoUploadStep onBack={onBack} onUploaded={handleUploaded} />;
}
